// extracted by mini-css-extract-plugin
export default {"wrapper":"form-builder-content_wrapper__KNbov"};